import React, { Component } from "react";
import "./VasBannersItemList.css";
import VasBannerItem from "./VasBannerItem";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";

// swiper bundle styles
import "swiper/swiper-bundle.min.css";

// swiper core styles
import "swiper/swiper.min.css";

// modules styles

SwiperCore.use([Pagination, Navigation]);

class VasBannersItemList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { banners } = this.props;

    if (banners === null || banners.length === 0) return null;

    return (
      <div className="container-vas-banners">

        {/* Navigation Buttons */}
        {/* <div class="vas-swiper-navigation-button prev" />
        <div class="vas-swiper-navigation-button next" /> */}

        <Swiper
          className="vas-banners-swiper"
          modules={[Pagination, Navigation]}
          slidesPerView={1.2}
          spaceBetween={0}
          observer={true}
          autoHeight={true}
          watchOverflow={true}
          breakpoints={{
            572: {
              slidesPerView: 2.4,
            },
            768: {
              slidesPerView: 4,
              slidesPerGroup:4
            },
          }}
          pagination={{
            clickable: true,
          }}
          navigation={{
            prevEl: ".vas-swiper-navigation-button.prev",
            nextEl: ".vas-swiper-navigation-button.next",
          }}
        >
          {banners.map((banner, i) => (
            <SwiperSlide key={`vas-item-${i + 1}`}>
              <VasBannerItem banner={banner} index={i} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}

export default VasBannersItemList;
